import { ThunkAction } from "redux-thunk";
import { AppStateType } from "..";
import {
  SET_IS_IMAGES_LOADING_IN_PROGRESS,
  SET_IMAGES,
  SET_TOTAL_IMAGES,
  SET_IS_IMAGES_DELETING_IN_PROGRESS,
  SET_SITE_IMAGES,
} from "../reducers/imageReducer";
import { imagesApi } from "../../api";
import { notification } from "antd";
import { IImage, ISiteImage } from "../../types";
import { getOneSite } from "./siteActions";

type SetIsImagesLoadingInProgress = {
  type: typeof SET_IS_IMAGES_LOADING_IN_PROGRESS;
  payload: { isImagesLoadingInProgress: boolean };
};

type SetImages = {
  type: typeof SET_IMAGES;
  payload: { images: IImage[] };
};

type SetSiteImages = {
  type: typeof SET_SITE_IMAGES;
  payload: { siteImages: ISiteImage[] };
};

type SetTotalImages = {
  type: typeof SET_TOTAL_IMAGES;
  payload: { imagesTotal: number };
};

type SetIsImageDeletingInProgress = {
  type: typeof SET_IS_IMAGES_DELETING_IN_PROGRESS;
  payload: { isImageDeletingInProgress: boolean };
};

export type ImageActionsTypes =
  | SetIsImagesLoadingInProgress
  | SetIsImageDeletingInProgress
  | SetImages
  | SetTotalImages
  | SetSiteImages;

export const setIsImagesLoadingInProgress = (
  isImagesLoadingInProgress: boolean
): SetIsImagesLoadingInProgress => ({
  type: SET_IS_IMAGES_LOADING_IN_PROGRESS,
  payload: { isImagesLoadingInProgress },
});

export const setIsImageDeletingInProgress = (
  isImageDeletingInProgress: boolean
): SetIsImageDeletingInProgress => ({
  type: SET_IS_IMAGES_DELETING_IN_PROGRESS,
  payload: { isImageDeletingInProgress },
});

export const setImages = (images: IImage[]): SetImages => ({
  type: SET_IMAGES,
  payload: { images },
});

export const setSiteImages = (siteImages: ISiteImage[]): SetSiteImages => ({
  type: SET_SITE_IMAGES,
  payload: { siteImages },
});

export const setTotalImages = (imagesTotal: number): SetTotalImages => ({
  type: SET_TOTAL_IMAGES,
  payload: { imagesTotal },
});

export type ImageThunkType = ThunkAction<
  Promise<void>,
  AppStateType,
  unknown,
  ImageActionsTypes
>;

export const getImages =
  (page: number, category: string, user: string): ImageThunkType =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsImagesLoadingInProgress(true));
      const response = await imagesApi.loadImages(page, category, user);
      if (response.status === "success") {
        console.log("response", response);
        dispatch(setTotalImages(response?.totalImages || 0));
        dispatch(setImages(response?.images || []));
      }
    } catch (e) {
      notification.error({
        message: "Error",
        description: "Error loading list of images",
      });
    } finally {
      dispatch(setIsImagesLoadingInProgress(false));
    }
  };

export const getSiteImages =
  (siteId: string): ImageThunkType =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsImagesLoadingInProgress(true));
      const response = await imagesApi.loadSiteImages(siteId);
      if (response.status === "success") {
        dispatch(setSiteImages(response?.images || []));
      }
    } catch (e) {
      notification.error({
        message: "Error",
        description: "Error loading list of images",
      });
    } finally {
      dispatch(setIsImagesLoadingInProgress(false));
    }
  };

export const deleteImage =
  (
    imageId: string,
    page: number,
    category: string,
    user: string
  ): ImageThunkType =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsImageDeletingInProgress(true));
      const response = await imagesApi.deleteImage(imageId);
      if (response.status === "success") {
        console.log("response", response);
        dispatch(getImages(page, category, user));
      }
    } catch (e) {
      notification.error({
        message: "Error",
        description: "Error image deleting",
      });
    } finally {
      dispatch(setIsImageDeletingInProgress(false));
    }
  };

export const deleteOneSiteImage =
  (imageId: string, siteId: string): ImageThunkType =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsImageDeletingInProgress(true));
      const response = await imagesApi.deleteOneSiteImage(imageId);
      if (response.status === "success") {
        console.log("response", response);
        //dispatch(getOneSite(siteId));
        dispatch(getSiteImages(siteId));
      }
    } catch (e) {
      notification.error({
        message: "Error",
        description: "Error image deleting",
      });
    } finally {
      dispatch(setIsImageDeletingInProgress(false));
    }
  };

export const deleteAllSiteImages =
  (siteId: string): ImageThunkType =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsImageDeletingInProgress(true));
      const response = await imagesApi.deleteAllSiteImages(siteId);
      if (response.status === "success") {
        console.log("response", response);
        //dispatch(getOneSite(siteId));
        dispatch(getSiteImages(siteId));
      }
    } catch (e) {
      notification.error({
        message: "Error",
        description: "Error image deleting",
      });
    } finally {
      dispatch(setIsImageDeletingInProgress(false));
    }
  };
